import useAppData from "../../hooks/useAppData";
import { motion } from "framer-motion";

const CallToAction = () => {
	const { settings } = useAppData();
	const rawNumber = settings?.whatsapp_number;
	const cleanNumber = rawNumber?.replace(/\D/g, "");
	const url = cleanNumber ? `https://wa.me/${cleanNumber}` : "#";

	return (
		<section className="container mx-auto md:px-4 md:py-15 lg:py-24">
			<div className="relative overflow-hidden md:rounded-3xl bg-slate-900 px-8 py-12 shadow-2xl md:px-16 md:py-20">
				{/* Background Decorative Gradient Blobs */}
				<div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-brand-500/10 blur-3xl" />
				<div className="absolute -bottom-20 -left-20 h-64 w-64 rounded-full bg-brand-500/10 blur-3xl" />

				<div className="relative z-10 flex flex-col items-center justify-between gap-8 lg:flex-row">
					{/* Content Section */}
					<div className="text-center lg:text-left">
						<h2 className="mb-4 text-3xl font-bold tracking-tight text-white md:text-4xl lg:max-w-xl">
							Need Help? We're Just a{" "}
							<span className="text-brand-400">Message Away</span>
						</h2>
						<p className="text-lg text-slate-400 md:text-xl">
							Our team is ready to assist you with fast, reliable answers.
						</p>
					</div>

					{/* CTA Button Section */}
					<div className="flex shrink-0 items-center">
						<a
							href={url}
							target="_blank"
							rel="noreferrer"
							className="group relative flex items-center gap-4 overflow-hidden rounded-full border border-white/10 bg-white/5 px-8 py-4 text-xl font-semibold text-white transition-all ha:bg-brand-500 ha:shadow-[0_0_30px_-5px_rgba(var(--brand-500),0.5)]"
						>
							{/* Animated Green Dot */}
							<div className="relative flex h-4 w-4">
								<motion.span
									animate={{ scale: [1, 1.5, 1], opacity: [0.5, 0, 0.5] }}
									transition={{ repeat: Infinity, duration: 2 }}
									className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"
								/>
								<span className="relative inline-flex h-4 w-4 rounded-full bg-green-500" />
							</div>

							<span>Chat with us now</span>

							{/* Subtle Shine Effect on Hover */}
							<div className="absolute inset-0 -translate-x-full bg-linear-to-r from-transparent via-white/10 to-transparent transition-transform duration-500 gh:translate-x-full" />
						</a>
					</div>
				</div>
			</div>
		</section>
	);
};

export default CallToAction;
